import Box, { BoxProps } from '@mui/material/Box';
import { BoxIcon } from '../../icons';

export interface ImageThumbnailProps extends BoxProps<'div', { to?: string }> {
  imageUrl?: string;
  alt?: string;
  objectFit?: 'cover' | 'contain';
  fallback?: React.ReactNode;
  hasBackground?: boolean;
}

const ImageThumbnail: React.FC<ImageThumbnailProps> = ({
  imageUrl,
  alt = 'thumbnail',
  objectFit = 'contain',
  fallback,
  hasBackground,
  sx = { width: '7rem', minWidth: '7rem', height: '7rem', minHeight: '7rem' },
  ...props
}) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: hasBackground
        ? (theme) => theme.palette.gray?.[50]
        : undefined,
      borderRadius: '1rem',
      ...(props.to && { cursor: 'pointer' }),
      ...sx,
    }}
    {...props}
  >
    {imageUrl ? (
      <Box
        component="img"
        src={imageUrl}
        alt={alt}
        crossOrigin="anonymous"
        sx={{ width: '100%', height: '100%', objectFit: objectFit }}
      />
    ) : (
      (fallback ?? <BoxIcon />)
    )}
  </Box>
);

export default ImageThumbnail;
